import { useEffect, useMemo, useState } from 'react'
import { Box } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Choice, MultipleChoiceQuestionProps } from './_props'
import useStyles from './_styles'

export default function MultipleChoiceQuestion({
    question,
    initialValue = [],
    onAnswer,
    onNext,
}: MultipleChoiceQuestionProps) {
    const classes = useStyles()

    const initialSelectedSet = useMemo(() => {
        const ids = Array.isArray(initialValue) ? initialValue : []
        return new Set(ids.map(String))
    }, [initialValue])

    const [selectedSet, setSelectedSet] = useState<Set<string>>(initialSelectedSet)

    useEffect(() => {
        setSelectedSet(initialSelectedSet)
    }, [initialSelectedSet])

    const toggleChoice = (choice: Choice) => {
        setSelectedSet((prev) => {
            const next = new Set(prev)
            if (next.has(choice.id)) {
                next.delete(choice.id)
            } else {
                next.add(choice.id)
            }
            const result = Array.from(next)
            onAnswer?.(result)
            return next
        })
    }

    return (
        <section className={classes.section}>
            <Box className={classes.choicesContainer}>
                {question.choices.map((c) => {
                    const selected = selectedSet.has(c.id)

                    return (
                        <button
                            key={c.id}
                            onClick={() => toggleChoice(c)}
                            aria-pressed={selected}
                            className={`${classes.choiceButton} ${selected ? 'selected' : ''}`}
                        >
                            {c.label}
                            {selected && <CheckCircleIcon className={classes.checkIcon} />}
                        </button>
                    )
                })}
            </Box>
        </section>
    )
}
